@if (isRmbRmc && !isAddAnother) {
<p>{{ "RENEWAL_TEXT" | globalTranslate }}</p>
}
<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  @if (!isPresumptive) {
  <p class="person-label">
    {{ "HOH" | globalTranslate }}:
    <span class="selectedIndName">{{ fullName }}</span>
  </p>
  }

  <h1 class="section-header">{{ "IMMIGRATION_INFO" | globalTranslate }}</h1>
  <hr />
  @if(!updateToNonQualifiedCitizenshipSwitch) {
    @if (!isPresumptive) {
    <p class="pb-3">{{ "IMMIGRATION_STATIC_TEXT1" | globalTranslate }}</p>
    } @if (!isPresumptive) {
    <p class="pb-3">{{ "IMMIGRATION_STATIC_TEXT2" | globalTranslate }}</p>
    } @if (!isPresumptive) {
    <p class="pb-3">
      {{ "IMMIGRATION_STATIC_TEXT3" | globalTranslate }}
      <span>{{ selectedIndividual | fullname }}</span>
      {{ "IMMIGRATION_STATIC_TEXT4" | globalTranslate }}
      <span>{{ selectedIndividual | fullname }}</span>
      {{ "IMMIGRATION_STATIC_TEXT5" | globalTranslate }}
    </p>
    }
  }
  @if(updateToNonQualifiedCitizenshipSwitch) {
    <p class="pb-3">{{ "IMMIGRATION_STATIC_TEXT26" | globalTranslate }}</p>
    <p class="pb-3">{{ "IMMIGRATION_STATIC_TEXT27" | globalTranslate }}</p>
    <p>{{ "IMMIGRATION_STATIC_TEXT28" | globalTranslate }}</p>
    <ul class="tips-list mb-4">
        <li>{{ "IMMIGRATION_STATIC_TEXT29" | globalTranslate }}</li>
        <li>{{ "IMMIGRATION_STATIC_TEXT30" | globalTranslate }}</li>
        <li>{{ "IMMIGRATION_STATIC_TEXT31" | globalTranslate }}</li>
    </ul>
      <mat-accordion multi class="info-accordion">
        <!-- Upload Button Panel -->
        <mat-expansion-panel class="info-expansion-panel accordion-container" [expanded]="true">
          <mat-expansion-panel-header class="info-header">
            <mat-panel-title class="info-panel-title">
              <span><img [src]="'assets/images/Icons/tool-tip-icon.svg'" alt="" /></span>
               <strong class="info-title">{{
                "IMMIGRATION_STATIC_TEXT32" | globalTranslate }}</strong>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="info-content">
            <p>
            <span [innerHTML]="'IMMIGRATION_STATIC_TEXT33' | globalTranslate"></span>
            <a class="lpr-exemption-link"  tabindex="0" [attr.aria-label]="'IMMIGRATION_STATIC_TEXT33_1' | globalTranslate" (click)="showImmigrationTypes(); $event.preventDefault()" (keydown.enter)="showImmigrationTypes(); $event.preventDefault()"><span class="lpr-exemption-link" [innerHTML]="'IMMIGRATION_STATIC_TEXT33_1' | globalTranslate"></span></a>
            <span [innerHTML]="'IMMIGRATION_STATIC_TEXT33_2' | globalTranslate"></span>
            </p>
          </div>
        </mat-expansion-panel> 
      </mat-accordion>
      <p class="m-5">{{ "IMMIGRATION_STATIC_TEXT34" | globalTranslate }} {{ selectedIndividual | fullname }} {{ "IMMIGRATION_STATIC_TEXT35" | globalTranslate }}</p>
  }
  <nh-alert type="warning" [isOpen]="showImmigrationWarning">
    <div class="row">
      <div class="col-auto icon">
        <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg" alt="warning" />
      </div>
      <div class="col message">
        <span [innerHTML]="'IMMIGRATION_WARNING' | globalTranslate"></span>
      </div>
    </div>
  </nh-alert>
      <div>
    <section [formGroup]="getControl('data')">
      <div class="row">
        <nh-field
          [attr.aria-required]="true"
          id="imm_eligibleImmigration"
          [mandatory]="true"
          [isRow]="true"
          label="{{ 'IF' | globalTranslate }} {{
            selectedIndividual | fullname
          }} {{ (!updateToNonQualifiedCitizenshipSwitch ? 'IMMIGRATION_STATIC_TEXT6' : 'IMMIGRATION_STATIC_TEXT37') | globalTranslate }}"
          class="label-section"
        >
          @if (!updateToNonQualifiedCitizenshipSwitch) {
          <nh-popover
            class="ps-1"
            content="{{ 'IMMIGRATION_STATIC_TEXT7' | globalTranslate }}"
          ></nh-popover>
        }
          @if (updateToNonQualifiedCitizenshipSwitch) {
          <nh-popover
            class="ps-1"
            content="{{ 'IMMIGRATION_STATIC_TEXT38' | globalTranslate }}"
          ></nh-popover>
          }
          <select
            nhTranslate
            name="eligibleImmigration"
            [attr.aria-label]="
              ('IF' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ((!updateToNonQualifiedCitizenshipSwitch ? 'IMMIGRATION_STATIC_TEXT6' : 'IMMIGRATION_STATIC_TEXT37') | globalTranslate)
            "
            [attr.disabled]="isEligible"
            [items]="tables.YESNOPNA"
            formControlName="eligibleImmigration"
            [required]="true"
          ></select>
          @if (!updateToNonQualifiedCitizenshipSwitch) {
          <small class="form-text text-muted">{{
            "IMMIGRATION_STATIC_TEXT8" | globalTranslate
          }}</small>
        }
        </nh-field>
      </div>

      @if (isY('data.eligibleImmigration')) {
      <div [formGroup]="getControl('data.immigration')">
        @if (!updateToNonQualifiedCitizenshipSwitch) {
        <nh-field
          [attr.aria-required]="true"
          id="imm_status"
          label="{{ 'WHAT_IS_2' | globalTranslate }} {{
            selectedIndividual | fullname
          }}{{ 'IMMIGRATION_STATIC_TEXT9' | globalTranslate }}?"
          class="label-section"
        >        
       
          <nh-popover
            class="ps-1"
            content="{{ 'IMMIGRATION_STATIC_TEXT20' | globalTranslate }}"
          ></nh-popover>
        
          @if (!isPresumptive) {
          <select
            nhTranslate
            name="status"
            [attr.aria-label]="
              ('WHAT_IS_2' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('IMMIGRATION_STATIC_TEXT9' | globalTranslate)
            "
            [items]="tables.ALIENSTATUS"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="status"
            (change)="otherStatus()"
            [required]="true"
          ></select>
          } @if (isPresumptive) {
          <select
            nhTranslate
            name="status"
            [attr.aria-label]="
              ('WHAT_IS_2' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('IMMIGRATION_STATIC_TEXT9' | globalTranslate)
            "
            [items]="
              tableCodeValue('ALIENSTATUS_PP', 'data.immigration.status')
            "
            [attr.disabled]="isImmigrationDisabled"
            formControlName="status"
            (change)="otherStatus()"
            [required]="true"
          ></select>
          }
        </nh-field>
      }
       @if (updateToNonQualifiedCitizenshipSwitch) {
        <nh-field
          [attr.aria-required]="updateToNonQualifiedCitizenshipSwitch"
          [mandatory]="updateToNonQualifiedCitizenshipSwitch"
          [isRow]="true"
          id="imm_currentImmigrationStatus"
          label="{{ 'IMMIGRATION_STATIC_TEXT40' | globalTranslate }} {{
            selectedIndividual | fullname
          }}{{ 'IMMIGRATION_STATIC_TEXT25' | globalTranslate }}?"
          class="label-section"
        >
        <select
            nhTranslate
            name="currentImmigrationStatus"
            [attr.aria-label]="
              ('IMMIGRATION_STATIC_TEXT40' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('IMMIGRATION_STATIC_TEXT25' | globalTranslate)
            "
            [items]="tables.CURRENTIMMISTATUS"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="currentImmigrationStatus"
            (change)="currentImmigrationStatusChange($event)"
            [required]="updateToNonQualifiedCitizenshipSwitch"
          ></select>
        </nh-field> 
        }
        @if (updateToNonQualifiedCitizenshipSwitch && getValue('data.immigration.currentImmigrationStatus')?.code === 'LP') {
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          [isRow]="true"
          id="imm_status"
          label="{{ 'IMMIGRATION_STATIC_TEXT39' | globalTranslate }} {{
            selectedIndividual | fullname
          }}{{ 'IMMIGRATION_STATIC_TEXT22' | globalTranslate }}"
          class="label-section"
        >
         <nh-popover
            class="ps-1"
            content="{{ 'IMMIGRATION_STATIC_TEXT36' | globalTranslate }}"
          ></nh-popover>
        
         @if (!isPresumptive) {
          <select
            nhTranslate
            name="status"
            [attr.aria-label]="
              ('WHAT_IS_2' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('IMMIGRATION_STATIC_TEXT9' | globalTranslate)
            "
            [items]="tables.ALIENSTATUS"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="status"
            (change)="otherStatus()"
            [required]="getValue('data.immigration.currentImmigrationStatus')?.code === 'LP'"
          ></select>
          } @if (isPresumptive) {
          <select
            nhTranslate
            name="status"
            [attr.aria-label]="
              ('WHAT_IS_2' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('IMMIGRATION_STATIC_TEXT9' | globalTranslate)
            "
            [items]="
              tableCodeValue('ALIENSTATUS_PP', 'data.immigration.status')
            "
            [attr.disabled]="isImmigrationDisabled"
            formControlName="status"
            (change)="otherStatus()"
            [required]="getValue('data.immigration.currentImmigrationStatus')?.code === 'LP'"
          ></select>
          }
        </nh-field>
      }
        @if (isEnabled('data.immigration.statusGainDate')) {
        <div>
          <nh-field
            [attr.aria-required]="false"
            id="imm_statusGainDate"
            [mandatory]="false"
            label="{{ 'IMMIGRATION_STATIC_TEXT10' | globalTranslate }} {{
              selectedIndividual | fullname
            }} {{ 'IMMIGRATION_STATIC_TEXT11' | globalTranslate }}"
            class="label-section"
          >
            <nh-datepicker [readOnly]="isImmigrationDisabled">
              <input
                type="text"
                name="statusGainDate"
                class="form-control"
                [attr.disabled]="isImmigrationDisabled"
                (change)="isInvalidDate($event)"
                formControlName="statusGainDate"
                bsDatepicker
                nh
                [maxDate]="today"
                [minDate]="minDate"
                [attr.aria-label]="
                  ('IMMIGRATION_STATIC_TEXT10' | globalTranslate) +
                  ' ' +
                  (selectedIndividual | fullname) +
                  ' ' +
                  ('IMMIGRATION_STATIC_TEXT11' | globalTranslate)
                "
              />
            </nh-datepicker>
          </nh-field>
        </div>
        }
      </div>
      }

      <div [formGroup]="getControl('data.immigration.document')">
        @if (isEnabled('data.immigration.document.documentDescription')) {
        <nh-field
          [attr.aria-required]="true"
          id="imm_documentDescription"
          [mandatory]="true"
          label="{{ 'IMMIGRATION_STATIC_TEXT12' | globalTranslate }}"
          class="label-section"
        >
          <input
            type="text"
            [required]="true"
            name="documentDescription"
            class="form-control"
            [attr.aria-label]="'IMMIGRATION_STATIC_TEXT12' | globalTranslate"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="documentDescription"
            maxlength="35"
          />
        </nh-field>
        } @if (isY('data.eligibleImmigration') && 
        ((!updateToNonQualifiedCitizenshipSwitch && getValue('data.immigration.status')?.code && getValue('data.immigration.status').code !== 'NA' && getValue('data.immigration.status').code !== 'UA') ||
         (updateToNonQualifiedCitizenshipSwitch && getValue('data.immigration.currentImmigrationStatus')?.code && 
          (getValue('data.immigration.currentImmigrationStatus').code !== 'LP' || 
           (getValue('data.immigration.currentImmigrationStatus').code === 'LP' && getValue('data.immigration.status')?.code && getValue('data.immigration.status').code !== 'NA' && getValue('data.immigration.status').code !== 'UA'))))) {
        <div>
          <p class="hint semibold">
            {{ "IMMIGRATION_STATIC_TEXT19" | globalTranslate }}
          </p>
        </div>
        } @if (isEnabled('data.immigration.document.docType')) {
        <nh-field
          id="imm_docType"
          label="{{ 'IMMIGRATION_STATIC_TEXT13' | globalTranslate }} {{
            selectedIndividual | fullname
          }}{{ 'IMMIGRATION_STATIC_TEXT14' | globalTranslate }}?"
          class="label-section"
          [mandatory]="false"
          [attr.aria-required]="false"
        >
          <select
            nhTranslate
            name="proxyDocType"
            aria-label="proxyDocType"
            [items]="tables.ALIENDOCTYPE"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="docType"
            (change)="onDocTypeChange()"
            [attr.aria-label]="
              ('IMMIGRATION_STATIC_TEXT13' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('IMMIGRATION_STATIC_TEXT14' | globalTranslate)
            "
          ></select>
        </nh-field>
        }

        <nh-alert
          type="warning"
          [isOpen]="
            isEnabled('data.immigration.document.docType') &&
            (showWarning1 || showWarning2 || showWarning3)
          "
        >
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
                alt=""
              />
            </div>
            <!-- globalTranslate -->
            <div class="col message">
              @if (showWarning1) {
              <span
                [innerHTML]="
                  'IMMIGRATION_DOCUMENT_WARNING1_EAC' | globalTranslate
                "
              ></span>
              } @if (showWarning2) {
              <span
                [innerHTML]="
                  'IMMIGRATION_DOCUMENT_WARNING1_PRC' | globalTranslate
                "
              ></span>
              } @if (showWarning3) {
              <span
                [innerHTML]="
                  'IMMIGRATION_DOCUMENT_WARNING2_ADFP' | globalTranslate
                "
              ></span>
              }
            </div>
            <!-- Original code with translate pipe
                  <div class="col message">
                    <span *ngIf="showWarning1"[innerHTML]="'IMMIGRATION_DOCUMENT_WARNING1' | translate : {docType1: 'RECEIPT' | translate, docType2: 'DOCUMENT_PASSPORT_EXPIRATION' | translate}"></span>
                    <span *ngIf="showWarning2"[innerHTML]="'IMMIGRATION_DOCUMENT_WARNING1' | translate : {docType1: 'ALIEN_NUMBER' | translate, docType2: 'RECEIPT' | translate}"></span>
                    <span *ngIf="showWarning3"[innerHTML]="'IMMIGRATION_DOCUMENT_WARNING2' | translate : {docType1: 'I-94'| translate, docType2: 'PASSPORT_NUMBER' | translate, docType3: 'DOCUMENT_PASSPORT_EXPIRATION' | translate}"></span>
                  </div>
                  -->
          </div>
        </nh-alert>

        @if ((isEnabled('data.immigration.document.docType') &&
        isEnabled('data.immigration.document.registrationNumber'))) {
        <nh-field
          [attr.aria-required]="false"
          id="imm_registrationNumber"
          [mandatory]="false"
          label="{{ 'ALIEN_NUMBER' | globalTranslate }}"
          class="label-section"
        >
          <div class="d-flex align-items-center alienNumber">
            <span class="pl-2 pe-3 tab-section">A </span>
            <input
              type="text"
              name="registrationNumber"
              class="form-control"
              [attr.disabled]="isImmigrationDisabled"
              formControlName="registrationNumber"
              placeholder="XXXXXXXXX"
              maxlength="9"
              mask="0*"
              (input)="onImmigrationChange($event)"
              (focusout)="onFocusOutAlienNumber($event)"
              [attr.aria-label]="'ALIEN_NUMBER' | globalTranslate"
            />
          </div>
          @if (isInvalidAlienNumber) {
          <div class="form-text invalid-name d-block">
            {{ "INVALID_ALIEN_NUMBER" | globalTranslate }}
          </div>
          }
        </nh-field>
        } @if (isEnabled('data.immigration.document.i94')) {
        <nh-field
          [attr.aria-required]="false"
          id="imm_i94"
          [mandatory]="false"
          label="{{ 'I-94' | globalTranslate }}"
          class="label-section"
        >
          <div class="nh-tooltip" aria-hidden="true">
            <span
              ><a class="toolTip">
                <img
                  [src]="'assets/images/Icons/tool-tip-icon.svg'"
                  alt="tooltip" /></a
            ></span>
            <span
              class="tooltiptext"
              [innerHTML]="'I94_POPOVER' | globalTranslate"
              placement="auto"
            ></span>
          </div>
          <span class="visually-hidden" aria-hidden="false">
            {{ "INFORMATION_tooltip" | globalTranslate }}
            {{ "I94_POPOVER" | globalTranslate }}</span
          >
          <input
            type="text"
            name="i94"
            class="form-control"
            [attr.aria-label]="'I-94' | globalTranslate"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="i94"
            placeholder="XXXXXXXXXXX"
            maxlength="11"
            (input)="onImmigrationChange($event)"
            (focusout)="onFocusOutI94Number()"
          />
          @if (isInvalidi94) {
          <span class="form-text invalid-name d-block">{{
            "INVALID_I94" | globalTranslate
          }}</span>
          }
        </nh-field>
        } @if
        (isEnabled('data.immigration.document.naturalizationCertificateNumber'))
        {
        <nh-field
          id="naturalizationCertificateNumber"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'NATURALIZATION_NUMBER' | globalTranslate }}"
          class="label-section"
        >
          <input
            type="text"
            name="naturalizationCertificateNumber"
            class="form-control"
            [attr.aria-label]="'NATURALIZATION_NUMBER' | globalTranslate"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="naturalizationCertificateNumber"
            maxlength="12"
          />
        </nh-field>
        } @if
        (isEnabled('data.immigration.document.certificateOfCitizenshipNumber'))
        {
        <nh-field
          id="imm_certificateOfCitizenshipNumber"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'CITIZENSHIP_CERTIFICATE' | globalTranslate }}"
          class="label-section"
        >
          <input
            type="text"
            name="certificateOfCitizenshipNumber"
            class="form-control"
            [attr.aria-label]="'CITIZENSHIP_CERTIFICATE' | globalTranslate"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="certificateOfCitizenshipNumber"
            maxlength="12"
          />
        </nh-field>
        } @if (isEnabled('data.immigration.document.sevisID')) {
        <nh-field
          id="imm_sevisID"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'SEVIS_ID' | globalTranslate }}"
          class="label-section"
        >
          <div class="d-flex align-items-center">
            <span class="pl-1">N</span><span class="pl-2 pe-2"> - </span>
            <input
              type="text"
              class="form-control"
              formControlName="sevisID"
              name="sevisID"
              placeholder="XXX-XXX-XXXX"
              mask="000-000-0000"
              [attr.aria-label]="'SEVIS_ID' | globalTranslate"
            />
          </div>
        </nh-field>
        } @if (isEnabled('data.immigration.document.cardNumber')) {
        <nh-field
          id="imm_cardNumber"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'RECEIPT' | globalTranslate }}"
          class="label-section"
        >
          <div class="nh-tooltip" aria-hidden="true">
            <span
              ><a class="toolTip">
                <img
                  [src]="'assets/images/Icons/tool-tip-icon.svg'"
                  alt="tooltip" /></a
            ></span>
            <span
              class="tooltiptext"
              [innerHTML]="'CARDNUMBER_POPOVER' | globalTranslate"
              placement="auto"
            ></span>
          </div>
          <span class="visually-hidden" aria-hidden="false">
            {{ "INFORMATION_tooltip" | globalTranslate }}
            {{ "CARDNUMBER_POPOVER" | globalTranslate }}</span
          >
          <input
            type="text"
            name="cardNumber"
            class="form-control"
            [attr.aria-label]="'RECEIPT' | globalTranslate"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="cardNumber"
            placeholder="SSS0000000000"
            mask="SSS0000000000"
            (input)="onImmigrationChange($event)"
          />
        </nh-field>
        } @if (isEnabled('data.immigration.document.visa')) {
        <nh-field
          id="imm_visa"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'VISA_NUMBER' | globalTranslate }}"
          class="label-section"
        >
          <input
            type="text"
            name="visa"
            class="form-control"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="visa"
            minlength="8"
            mask="AAAAAAAA"
            [attr.aria-label]="'VISA_NUMBER' | globalTranslate"
          />
        </nh-field>
        } @if (isEnabled('data.immigration.document.passport')) {
        <nh-field
          id="imm_passport"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'PASSPORT_NUMBER' | globalTranslate }}"
          class="label-section"
        >
          <input
            type="text"
            name="passport"
            maxlength="20"
            class="form-control"
            [attr.aria-label]="'PASSPORT_NUMBER' | globalTranslate"
            [attr.disabled]="isImmigrationDisabled"
            formControlName="passport"
            (input)="onImmigrationChange($event)"
          />
        </nh-field>
        } @if (isEnabled('data.immigration.document.countryIssuance')) {
        <nh-field
          id="imm_countryIssuance"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'COUNTRY_ISSUANCE' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="countryIssuance"
            [attr.aria-label]="'COUNTRY_ISSUANCE' | globalTranslate"
            [items]="
              tableCodeValue(
                'COUNTRY',
                'data.immigration.document.countryIssuance'
              )
            "
            [attr.disabled]="isImmigrationDisabled"
            formControlName="countryIssuance"
            [required]="countryIssuance"
          ></select>
        </nh-field>
        } @if (isEnabled('data.immigration.document.expDate')) {
        <nh-field
          id="imm_expDate"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'DOCUMENT_PASSPORT_EXPIRATION' | globalTranslate }}"
          class="label-section"
        >
          <nh-datepicker [readOnly]="isImmigrationDisabled">
            <input
              type="text"
              name="expDate"
              class="form-control"
              [attr.disabled]="isImmigrationDisabled"
              formControlName="expDate"
              bsDatepicker
              nh
              [required]="expDate"
              [minDate]="today"
              (bsValueChange)="onImmigrationChange($event, 'expDate')"
              (change)="onImmigrationChange($event, 'expDate')"
              (focusout)="onFocusOutExpDate($event)"
              [attr.aria-label]="
                'DOCUMENT_PASSPORT_EXPIRATION' | globalTranslate
              "
            />
          </nh-datepicker>
          @if (isInvalidExpDate) {
          <div class="form-text invalid-name d-block">
            {{ "INVALID_MAX_DATE" | globalTranslate }}
          </div>
          }
        </nh-field>
        }
      </div>
    </section>
  </div>
  @if (!isPresumptive) {
  <div>
    <h2 class="section-header">
      {{ "MILITARY_INFORMATION" | globalTranslate }}
    </h2>
    <hr />
    <section [formGroup]="getControl('data.militaryInfo')">
      @if (isMilitaryEligible) {
      <nh-field
        id="imm_isVeteranOrActiveDuty"
        label="{{ 'IS_1' | globalTranslate }}{{
          selectedIndividual | fullname
        }} {{ 'IS_VETERAN' | globalTranslate }}"
        [mandatory]="false"
        [attr.aria-required]="false"
        class="label-section"
      >
        <select
          nhTranslate
          name="isVeteranOrActiveDuty"
          [attr.aria-label]="
            ('IS_1' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('IS_VETERAN' | globalTranslate)
          "
          formControlName="isVeteranOrActiveDuty"
          [items]="
            tableCodeValue('YESNO', 'data.militaryInfo.isVeteranOrActiveDuty')
          "
        ></select>
      </nh-field>
      } @if (isMilitaryEligible) {
      <nh-field
        id="imm_isSpouseVeteranOrActiveDuty"
        label="{{ 'IMMIGRATION_STATIC_TEXT15' | globalTranslate }} {{
          selectedIndividual | fullname
        }}{{ 'IMMIGRATION_STATIC_TEXT16' | globalTranslate }}"
        [mandatory]="false"
        [attr.aria-required]="false"
        class="label-section"
      >
        <select
          nhTranslate
          name="isSpouseVeteranOrActiveDuty"
          [attr.aria-label]="
            ('IMMIGRATION_STATIC_TEXT15' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('IMMIGRATION_STATIC_TEXT16' | globalTranslate)
          "
          formControlName="isSpouseVeteranOrActiveDuty"
          [items]="
            tableCodeValue(
              'YESNO',
              'data.militaryInfo.isSpouseVeteranOrActiveDuty'
            )
          "
        ></select>
      </nh-field>
      } @if (parentalEligibility &&
      isEnabled('data.militaryInfo.isParentVeteranOrActiveDuty')) {
      <nh-field
        id="imm_isParentVeteranOrActiveDuty"
        label="{{ 'IMMIGRATION_STATIC_TEXT17' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'IMMIGRATION_STATIC_TEXT18' | globalTranslate }}"
        [mandatory]="false"
        [attr.aria-required]="false"
        class="label-section"
      >
        <select
          nhTranslate
          name="isParentVeteranOrActiveDuty"
          [attr.aria-label]="
            ('IMMIGRATION_STATIC_TEXT17' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('IMMIGRATION_STATIC_TEXT18' | globalTranslate)
          "
          formControlName="isParentVeteranOrActiveDuty"
          [items]="
            tableCodeValue(
              'YESNO',
              'data.militaryInfo.isParentVeteranOrActiveDuty'
            )
          "
        ></select>
      </nh-field>
      }
    </section>
  </div>
  }
</nh-form>